var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_statistics"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24824",
    "data-name": "\\uC0AC\\uAC01\\uD615 24824",
    width: 24,
    height: 24,
    fill: "#f1f1f1",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10734",
    "data-name": "\\uD328\\uC2A4 10734",
    d: "M493.614,395.823a7.586,7.586,0,0,0-5.4-2.237h-.184a.319.319,0,0,0-.319.319v.88a6.361,6.361,0,1,0,6.831,6.942h.991a.319.319,0,0,0,.318-.32v-.183A7.585,7.585,0,0,0,493.614,395.823Zm-4.9-1.213a6.634,6.634,0,0,1,6.111,6.11h-6.111Zm-.687,7.116h5.5a5.356,5.356,0,1,1-5.822-5.933v5.614A.32.32,0,0,0,488.03,401.726Z",
    transform: "translate(-476.851 -388.586)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatistics);
export default __webpack_public_path__ + "static/media/icon_statistics.35848f85584ed5ca42de6d8d7e03b6c3.svg";
export { ForwardRef as ReactComponent };